import React from 'react'
import styles from './styles.module.scss'
export const StickyFooter = ({ children }: { children: React.ReactNode }) => {
  return <footer className={`${styles.footer}   `}>{children}</footer>
}
